interface Answer {
  apply_form_no: string;
  answer: string;
  answer_etc: string;
  answer_kbn: string;
}

/**
 *  保存していたローカルストレージから以下のkeyで取得する。
 * */
export function getAnswers(auditionId: string, examinationNo: number): Answer[] | undefined {
  // ローカルストレージからデータを取得
  const data = localStorage.getItem(auditionId + '_' + examinationNo);
  if (!data) return;
  console.debug('データを取得', data);
  const answers = JSON.parse(data) as Answer[];
  // 取得したデータを返す
  return answers;
}

/**
 *  ローカルストレージに以下のkeyで保存する。
 * */
export function setAnswers(data: Answer[], auditionId: string, examinationNo: number) {
  const key = auditionId + '_' + examinationNo;
  console.debug('データを保存', data);
  localStorage.setItem(key, JSON.stringify(data));
}

/**
 *  保存していたローカルストレージから以下のkeyで削除する。
 * */
export const deleteAnswers = (auditionId: string, examinationNo: number) => {
  console.debug('データを削除');
  const key = auditionId + '_' + examinationNo;

  localStorage.removeItem(key);
};
